export function BasicInformation({ eventType, onFormDataChange }) {
  function handleChange(field, value) {
    onFormDataChange({ 
      [field]: value 
    })
  }

  return (
    <div className="space-y-8">
      <h2 className="text-xl font-bold text-gray-800">Basic Information</h2>
      
      <div className="bg-white rounded-lg p-6 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Date Field */}
          <div className="space-y-2">
            <label className="text-gray-600">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-2 rounded-md bg-gray-50 border border-gray-200"
              onChange={(e) => handleChange('date', e.target.value)}
            />
          </div>

          {/* Location Field */}
          <div className="space-y-2">
            <label className="text-gray-600">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-2 rounded-md bg-gray-50 border border-gray-200"
              placeholder="Enter location"
              onChange={(e) => handleChange('location', e.target.value)}
            />
          </div>

          {/* Weight Field */}
          <div className="space-y-2">
            <label className="text-gray-600">
              Weight (lbs) <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              step="0.1"
              className="w-full p-2 rounded-md bg-gray-50 border border-gray-200"
              onChange={(e) => handleChange('weight', e.target.value)}
            />
          </div>

          {/* Height Field */}
          <div className="space-y-2">
            <label className="text-gray-600">
              Height (inches) <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              step="0.1"
              className="w-full p-2 rounded-md bg-gray-50 border border-gray-200"
              onChange={(e) => handleChange('height', e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  )
} 